<template>
  <el-dialog
    title="Edit Entry"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :show-close="false"
    @close="closeDialog()"
    width="400px"
  >
    <el-form label-width="80px" :model="form" :rules="rules" ref="form">
      <el-form-item :label="$t('text.time')" prop="time">
        {{ form.time }}
      </el-form-item>
      <el-form-item :label="$t('text.comment')" prop="pour">
        <el-input v-model="form.pour" type="textarea"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button class="save-btn min-w-80" @click="save()">{{
        $t('text.save').toUpperCase()
      }}</el-button>
      <el-button class="cancel-btn min-w-80" @click="closeDialog()">{{
        $t('text.cancel').toUpperCase()
      }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      index: '',
      form: {
        time: '',
        pour: ''
      },
      rules: {
        time: [
          {
            required: true,
            message: 'time is required',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    openDialog() {
      this.dialogVisible = true
    },
    closeDialog() {
      this.form = {
        time: '',
        pour: ''
      }
      this.$refs.form.resetFields()
      this.dialogVisible = false
    },
    save() {
      this.$refs.form.validate(valid => {
        if (valid) {
          //store the original time (remove UTC offset apply)
          let data = this.$parent.commentData[this.index]
          data.pour = this.form.pour

          let volData = this.$parent.volData[this.index]
          if (volData) {
            data.localtime = volData.localtime
            data.time = volData.time
          }
          this.$set(this.$parent.commentData, this.index, data)
          this.closeDialog()
        }
      })
    }
  }
}
</script>
